import { forwardRef } from 'react';

import { FastForward } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/shadcn/ui/tooltip';
import { cn } from '@/utils';

const TrackerStateIconSkipPact = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ className, ...props }, ref) => {
    return (
      <TooltipProvider delayDuration={50}>
        <Tooltip>
          <TooltipTrigger asChild>
            <FastForward color="green" className={cn(className)} {...props} ref={ref} />
          </TooltipTrigger>
          <TooltipPortal container={document.getElementsByTagName('body')[0]}>
            <TooltipContent side="bottom" className="z-10 text-xs">
              PACT skipped <br /> due to direct CWEB swap
            </TooltipContent>
          </TooltipPortal>
        </Tooltip>
      </TooltipProvider>
    );
  }
);

TrackerStateIconSkipPact.displayName = 'TrackerStateIconSkipPact';

export default TrackerStateIconSkipPact;
